module.exports = __webpack_public_path__ + "img/maintenance-3.a831eb83.gif";